export default __webpack_public_path__ + "static/media/PEUGEOT_02.42a191e1.gif";